import styled from 'styled-components';

export const Error = styled.p`
  color: red;
`;
